import { ValidatorFn, AbstractControl } from '@angular/forms';

export function maxPhoneLengthValidator(length: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const phone = control.value ? control.value.split(' ').join('').split('-').join('') : [];
    return phone.length > length ? { maxPhoneLength: { value: control.value } } : null;
  };
}
